const SELECTORS = {
  swiperContainer: '.recommendation-wrapper',
  swiperContainerMobile: '.for-mobile .recommendation-wrapper',
};

/**
 * @param Swiper
 */
const initProductSlider = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainer);
  const swiperOptions = {
    freeMode: true,
    slidesPerView: 'auto',
    spaceBetween: '20',
    breakpoints: {
      640: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 50,
      },
    },
  };

  if (swiperContainer && Swiper) {
    // eslint-disable-next-line no-unused-vars
    const categorySwiper = new Swiper(swiperContainer, swiperOptions);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initProductSlider(module.Swiper);
  });
});
